"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_YET_FILED = exports.NOT_FILED = exports.UNABLE_TO_UPLOAD = exports.INCOME_GOVERNMENT = exports.INCOME_LOW = void 0;
var INCOME_LOW = 'incomeLow';
exports.INCOME_LOW = INCOME_LOW;
var INCOME_GOVERNMENT = 'incomeGovernment';
exports.INCOME_GOVERNMENT = INCOME_GOVERNMENT;
var UNABLE_TO_UPLOAD = 'unableToUpload'; // Required to file but has not done so

exports.UNABLE_TO_UPLOAD = UNABLE_TO_UPLOAD;
var NOT_FILED = 'notFiled'; // Has not filed yet for the current year but still within the window to file

exports.NOT_FILED = NOT_FILED;
var NOT_YET_FILED = 'notYetFiled';
exports.NOT_YET_FILED = NOT_YET_FILED;